


























import { apiPageConfigGetStateContentByApp } from '@/api'
import { base64UrlDecode, rot13 } from 'vtils'
import { computed } from '@vue/composition-api'
import {
  defineClassComponent,
  useApi,
  useQuery,
  useShareParams,
} from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: this.data.value.pageTitle,
        }))
      }

      query = useQuery<{
        q: string
      }>()

      data = computed<{
        pageTitle: string
        resourcePositionId: string
        sharePosterId: string
        useSharePosterUrl: string
      }>(() => JSON.parse(base64UrlDecode(rot13(this.query.q))))

      shareParams = useShareParams(
        this.data.value.sharePosterId,
        !this.data.value.useSharePosterUrl,
      )

      apiData = useApi(() =>
        apiPageConfigGetStateContentByApp({
          stateId: this.data.value.resourcePositionId,
          pageIndex: 1,
          pageSize: 100,
        }).then(res => res.list!),
      )
    },
)
